import styled, {css} from 'styled-components';

import {InfoDropdown} from '@edna/components';
import {Th as BaseTh, Td, Tr} from '@edna/components/Table';
import {mixins} from '@edna/components/styles';
import KeyboardArrowRightIcon from '@edna/icons/keyboardArrowRight.svg';
import {hexToRgba} from '@edna/utils';

import {TableHead} from 'src/components/List';

export const Th = styled(BaseTh)`
  display: inline-block;
`;

export const getLicenseTableCellWidth = (widths: string[]) =>
  widths.reduce(
    (result, width, index) =>
      `${result}

      &:nth-child(${index + 1}) {
        width: ${width};
        min-width: ${width};
      }
  `,
    '',
  );

const SLIDER_WIDTH = '44px';

export const TableWrapper = styled.div`
  ${mixins.stack({direction: 'ROW', justify: 'center', align: 'stretch'})};
  overflow: hidden;

  ${({theme}) => css`
    border: 1px solid ${theme.palette.grey200};
    border-radius: ${theme.borderRadius.br1};
  `};
`;

export const TableContent = styled.div<{columnsWidth: string[]}>`
  ${mixins.f2};
  width: 100%;
  overflow: auto;

  /* Firefox */
  scrollbar-width: none;

  /* Internet Explorer/Edge */
  -ms-overflow-style: none;

  /* Chrome, Safari, and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  ${({theme, columnsWidth}) => css`
    ${Td}, ${Th} {
      ${getLicenseTableCellWidth(columnsWidth)};
    }

    ${Tr}, ${TableHead} {
      width: calc(${columnsWidth.join(' + ')});
      padding: 0 ${theme.spacing.s1};
    }
  `};
`;

export const Slider = styled.div<{toRight?: boolean}>`
  ${mixins.stack({justify: 'center', align: 'center'})}
  z-index: 1;
  overflow: hidden;
  width: ${SLIDER_WIDTH};
  cursor: pointer;

  ${({theme, toRight}) => css`
    box-shadow: 0 2px 6px -1px ${hexToRgba(theme.branding.content.primary, '16%')};
    background: ${theme.branding.backgrounds.primary};
    border: 1px solid ${theme.palette.grey200};
    border-radius: ${theme.borderRadius.br1};

    svg {
      transition: transform ${theme.animation.duration}ms;
      transform: rotate(${toRight ? 'none' : '-180deg'});
    }
  `};
`;

export const ArrowIcon = styled(KeyboardArrowRightIcon)<{isOpen: boolean}>`
  ${mixins.wh('16px')}
  position: relative;
  top: 2px;
  transform: rotate(${({isOpen}) => (isOpen ? '-90deg' : 'none')});
`;

export const More = styled.div`
  ${mixins.stack({direction: 'ROW', align: 'center'})}
  ${mixins.f3}
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
  margin-top: ${({theme}) => theme.spacing.s2};
  color: ${({theme}) => theme.branding.content.secondary};
`;

export const InlineHint = styled(InfoDropdown)`
  top: ${({theme}) => theme.spacing.s1};
  display: inline-block;
`;
